// Library Methods
import { useTranslation } from "react-i18next";
import { useContext, useMemo } from "react";

// Components
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

// Utils
import {
  getExamSectionText,
  getReportExamsSortedByGroupId,
} from "src/utils/exams/examReportsHelper";

// Contexts
import { ReportContext } from "src/contexts/reports/ReportContext";

const MultiExamReportHeader = () => {
  const { t } = useTranslation();
  const { exam } = useContext(ReportContext);

  // return exam sections in the order they were completed
  const allExamSections = useMemo(() => {
    if (exam) {
      return getReportExamsSortedByGroupId(exam);
    }

    return [];
  }, [exam]);

  const completedExams = useMemo(
    () => allExamSections.filter((e) => Boolean(e.completionDate)),
    [allExamSections]
  );

  const uncompletedExams = useMemo(
    () => allExamSections.filter((e) => !Boolean(e.completionDate)),
    [allExamSections]
  );

  return (
    <Grid container sx={{ display: "flex" }} className="retinalogik-package">
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          border: "1px solid black",
          borderRadius: "4px",
          padding: "8px",
          gap: { xs: "8px", md: "24px" },
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <Grid item xs={12} md={6}>
          {completedExams?.length > 0 ? (
            <>
              <Typography fontSize="14px" fontWeight={600} mb="4px">
                {t("Completed Exams")}:
              </Typography>
              {completedExams?.map((completedExam) => (
                <Typography key={completedExam?.id} fontSize="14px">
                  {getExamSectionText(completedExam, t)}
                </Typography>
              ))}
            </>
          ) : (
            <Typography fontSize="14px">
              <span style={{ fontWeight: 600 }}>{t("Completed Exams")}:</span>{" "}
              {t("None")}
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} md={6}>
          {uncompletedExams?.length > 0 ? (
            <>
              <Typography fontSize="14px" fontWeight={600} mb="4px">
                {t("Uncompleted Exams")}:
              </Typography>
              {uncompletedExams?.map((uncompletedExam) => (
                <Typography key={uncompletedExam?.id} fontSize="14px">
                  {getExamSectionText(uncompletedExam, t)}
                </Typography>
              ))}
            </>
          ) : (
            <Typography fontSize="14px">
              <span style={{ fontWeight: 600 }}>{t("Uncompleted Exams")}:</span>{" "}
              {t("None")}
            </Typography>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MultiExamReportHeader;
